const clarityTrack = (key, value) => {
  if (window.clarity) {
    try {
      window.clarity('set', key, value);
    } catch {
      // Analytics must not interrupt the measured task.
    }
  }
};

const safeInstitutionPseudonym = (value) =>
  typeof value === 'string' && /^[0-9a-f]{16}$/.test(value) ? value : 'unknown';

export const clarityEvent = (name) => {
  if (window.clarity) {
    window.clarity('event', name);
  }
};

export const identifyUser = (user) => {
  const userId = user?.id;
  if (typeof userId === 'string' || typeof userId === 'number') {
    const id = String(userId);
    if (/^[a-zA-Z0-9_-]{1,128}$/.test(id) && window.clarity) {
      try {
        window.clarity('identify', id);
      } catch {
        // Analytics must not interrupt authentication.
      }
    }
  }

  const pseudonym = safeInstitutionPseudonym(user?.institution_pseudonym);
  if (pseudonym !== 'unknown') {
    clarityTrack('institution_pseudonym', pseudonym);
  }
};

export const trackUserContext = (user) => {
  clarityTrack('institution_pseudonym', safeInstitutionPseudonym(user.institution_pseudonym));
  clarityTrack('user_role', user.roleString || String(user.role_id));
};

// Every auth view is one route, reached through canonical URLs, so filtering
// sessions by flow no longer depends on which URL someone arrived by.
export const trackAuthView = (view) => clarityTrack('auth_view', view);

export const trackSessionEndNotice = (reason) => clarityTrack('session_end_reason', reason);

// BL-008: the login outcome events themselves reach Clarity through
// utils/telemetry (login_started / login_succeeded / login_failed, for every
// sign-in method). Clarity's `event` calls carry no payload, so the reason and
// how long it took ride as `set` tags on the same session — set before the
// terminal event, so a failed session is findable by reason and a slow one by
// duration.
export const trackLoginOutcome = (durationMs, failureCategory) => {
  clarityTrack('login_duration_ms', String(durationMs));
  if (failureCategory) clarityTrack('login_failure_category', failureCategory);
};

export const trackCourseContext = (course) => {
  const courseId = course?.id;
  const id = typeof courseId === 'string' || typeof courseId === 'number' ? String(courseId) : '';
  clarityTrack('course_id', /^[a-zA-Z0-9_-]{1,128}$/.test(id) ? id : 'unknown');
};

export const trackStageContext = (stageId) => {
  clarityTrack('course_stage', String(stageId));
};

export const trackStageSubmitted = (type) =>
  clarityTrack('stage_submitted', type);

export const trackStageApproved = (approved) =>
  clarityTrack('stage_approved', String(approved));

export const trackFeedbackCompleted = () =>
  clarityTrack('feedback_completed', 'true');

export const trackCourseCompleted = (courseId) =>
  clarityTrack('course_completed', String(courseId));

// Surveys open as a modal over whatever page the user is on, so there is no
// URL to filter by: these events and tags are what make those sessions findable.
export const trackSurveyShown = (surveyId, process) => {
  clarityTrack('survey_id', String(surveyId));
  clarityTrack('survey_process', process || 'unknown');
  clarityEvent('survey_shown');
};

export const trackSurveyAnswered = () => clarityEvent('survey_answered');

export const trackSurveyCompleted = () => clarityEvent('survey_completed');

export const trackSurveyDismissed = () => clarityEvent('survey_dismissed');
